import { usersAction, UserActionTypes } from "../../types/user";
import { Dispatch } from "react";
import axios from "axios";
import { Url } from "../../types/url";
import httpClient from "../../utils/httpClient";
import history from "../../utils/history";

export const getUserToken = (login: string, password: string) => {
  return async (dispatch: Dispatch<usersAction>): Promise<void> => {
    try {
      dispatch({
        type: UserActionTypes.POST_USER_TOKEN,
      });

      const response = await axios.post(
        Url.TokenServer,
        `client_id=sechenov-service&grant_type=password&username=${login}&password=${password}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      httpClient.setAccessToken(response?.data?.access_token);
      httpClient.setRefreshToken(response?.data?.refresh_token);

      dispatch({
        type: UserActionTypes.POST_USER_TOKEN_SUCCESS,
        payload: response?.data?.access_token,
      });

      dispatch({
        type: UserActionTypes.POST_USER_LOGIN,
        payload: login,
      });

      // @ts-ignore
      dispatch(getUserInfo());
    } catch (e) {
      dispatch({
        type: UserActionTypes.POST_USER_TOKEN_ERROR,
        payload: String(e),
      });
    }
  };
};

export const getUserInfo = () => {
  return async (dispatch: Dispatch<usersAction>): Promise<void> => {
    try {
      const userInfoRes = await axios.post(Url.UserInfo);

      const gradeRes = !userInfoRes?.data?.roles?.includes("validator")
        ? await axios.get("/api/v0.1/upload/grade")
        : { data: {} };

      dispatch({
        type: UserActionTypes.POST_USER_INFO_SUCCESS,
        payload: { ...userInfoRes?.data, statuses: gradeRes.data },
      });

      if (window.location.pathname === "/login") {
        history.push("/");
      }
    } catch (e) {
      dispatch({
        type: UserActionTypes.POST_USER_INFO_ERROR,
        payload: String(e),
      });
    }
  };
};

export const updateToken = (token: string) => {
  return async (dispatch: Dispatch<usersAction>): Promise<void> => {
    try {
      const response = await axios.post(
        Url.TokenServer,
        `client_id=sechenov-service&grant_type=refresh_token&refresh_token=${token}`,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      httpClient.setAccessToken(response?.data?.access_token);
      httpClient.setRefreshToken(response?.data?.refresh_token);

      dispatch({
        type: UserActionTypes.UPDATE_TOKEN,
        payload: response.data.access_token,
      });
    } catch (e) {
      dispatch({
        type: UserActionTypes.POST_USER_TOKEN_ERROR,
        payload: String(e),
      });
    }
  };
};
